import { render, staticRenderFns } from "./bcylsljl.vue?vue&type=template&id=39e1bff4&scoped=true&"
import script from "./bcylsljl.vue?vue&type=script&lang=js&"
export * from "./bcylsljl.vue?vue&type=script&lang=js&"
import style0 from "./bcylsljl.vue?vue&type=style&index=0&id=39e1bff4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e1bff4",
  null
  
)

export default component.exports